{
  "_meta": {
    "description": "Canonical reference list for the Iron Lab Explainer. Each entry keyed by the citation slug used in UI copy and engine citation arrays. DOIs verified against the master bibliography at Dropbox/Femme Fortified/Research Literature/References.md.",
    "source": "../../../Research Literature/References.md",
    "last_updated": "2026-05-01",
    "topic_order": [
      "ferritin_thresholds",
      "hemoglobin_thresholds",
      "iron_studies",
      "red_cell_indices",
      "inflammation_adjustment",
      "iron_overload",
      "iron_biology_clinical_context",
      "morphology_differential",
      "functional_iron_deficiency",
      "anemia_of_chronic_disease"
    ]
  },
  "entries": {
    "addo_2025": {
      "topic": "ferritin_thresholds",
      "short": "Addo et al. 2025",
      "apa": "Addo, O. Y., Mei, Z., Jefferds, M. E. D., Jenkins, M., Flores-Ayala, R., Williams, A. M., Young, M. F., Luo, H., Ko, Y.-A., Papassotiriou, I., Palmieri, M., Mesarina, K., Bhutta, Z., Suchdev, P. S., & Brittenham, G. M. (2025). Physiologically based serum ferritin thresholds for iron deficiency among women and children from Africa, Asia, Europe, and Central America. The Lancet Global Health, 13(5), e831–e842.",
      "doi_url": "https://doi.org/10.1016/S2214-109X(25)00009-9"
    },
    "addo_2019": {
      "topic": "hemoglobin_thresholds",
      "short": "Addo et al. 2019",
      "apa": "Addo, Y., Yu, E. X., Williams, A., Young, M. F., Sharma, A., Mei, Z., Jefferds, M. E., & Suchdev, P. (2019). Evaluation of hemoglobin cutoffs for defining anemia in a multinational sample of healthy individuals: The BRINDA project (OR07-07-19). Current Developments in Nutrition, 3(Suppl. 1), nzz034.OR07-07-19.",
      "doi_url": "https://doi.org/10.1093/cdn/nzz034.OR07-07-19"
    },
    "mei_2021": {
      "topic": "ferritin_thresholds",
      "short": "Mei et al. 2021",
      "apa": "Mei, Z., Addo, O. Y., Jefferds, M. E., Sharma, A. J., Flores-Ayala, R. C., & Brittenham, G. M. (2021). Physiologically based serum ferritin thresholds for iron deficiency in children and non-pregnant women: A US National Health and Nutrition Examination Surveys (NHANES) serial cross-sectional study. The Lancet Haematology, 8(8), e572–e582.",
      "doi_url": "https://doi.org/10.1016/S2352-3026(21)00168-X"
    },
    "mei_2024": {
      "topic": "ferritin_thresholds",
      "short": "Mei et al. 2024",
      "apa": "Mei, Z., Addo, O. Y., Jefferds, M. E. D., Flores-Ayala, R. C., & Brittenham, G. M. (2024). Physiologically based trimester-specific serum ferritin thresholds for iron deficiency in US pregnant women. Blood Advances, 8(14), 3745–3753.",
      "doi_url": "https://doi.org/10.1182/bloodadvances.2024013460"
    },
    "mei_2025": {
      "topic": "ferritin_thresholds",
      "short": "Mei et al. 2024",
      "apa": "Mei, Z., Addo, O. Y., Jefferds, M. E. D., Flores-Ayala, R. C., & Brittenham, G. M. (2024). Physiologically based trimester-specific serum ferritin thresholds for iron deficiency in US pregnant women. Blood Advances, 8(14), 3745–3753.",
      "doi_url": "https://doi.org/10.1182/bloodadvances.2024013460",
      "note": "Slug mei_2025 is an alias we retained during editorial drafting; DOI resolves to the 2024 publication."
    },
    "galetti_2021": {
      "topic": "ferritin_thresholds",
      "short": "Galetti et al. 2021",
      "apa": "Galetti, V., Stoffel, N. U., Sieber, C., Zeder, C., Moretti, D., & Zimmermann, M. B. (2021). Threshold ferritin and hepcidin concentrations indicating early iron deficiency in young women based on upregulation of iron absorption. EClinicalMedicine, 39, 101052.",
      "doi_url": "https://doi.org/10.1016/j.eclinm.2021.101052"
    },
    "mccarthy_2024": {
      "topic": "ferritin_thresholds",
      "short": "McCarthy et al. 2024",
      "apa": "McCarthy, E. K., Schneck, D., Basu, S., Xenopoulos-Oddsson, A., McCarthy, F. P., Kiely, M. E., & Georgieff, M. K. (2024). Longitudinal evaluation of iron status during pregnancy: A prospective cohort study in a high-resource setting. The American Journal of Clinical Nutrition, 120(6), 1259–1268.",
      "doi_url": "https://doi.org/10.1016/j.ajcnut.2024.08.010"
    },
    "bothwell_2000": {
      "topic": "iron_biology_clinical_context",
      "short": "Bothwell 2000",
      "apa": "Bothwell, T. H. (2000). Iron requirements in pregnancy and strategies to meet them. The American Journal of Clinical Nutrition, 72(1 Suppl.), 257S–264S.",
      "doi_url": "https://doi.org/10.1093/ajcn/72.1.257S"
    },
    "milman_2011": {
      "topic": "iron_biology_clinical_context",
      "short": "Milman 2011",
      "apa": "Milman, N. (2011). Iron in pregnancy — How do we secure an appropriate iron status in the mother and child? Annals of Nutrition and Metabolism, 59(1), 50–54.",
      "doi_url": "https://doi.org/10.1159/000332129"
    },
    "butwick_2021": {
      "topic": "hemoglobin_thresholds",
      "short": "Butwick & McDonnell 2021",
      "apa": "Butwick, A. J., & McDonnell, N. (2021). Antepartum and postpartum anemia: A narrative review. International Journal of Obstetric Anesthesia, 47, 102985.",
      "doi_url": "https://doi.org/10.1016/j.ijoa.2021.102985"
    },
    "akesson_2002": {
      "topic": "iron_biology_clinical_context",
      "short": "Åkesson et al. 2002",
      "apa": "Åkesson, A., Bjellerup, P., Berglund, M., Bremme, K., & Vahter, M. (2002). Soluble transferrin receptor: Longitudinal assessment from pregnancy to postlactation. Obstetrics & Gynecology, 99(2), 260–266.",
      "doi_url": "https://doi.org/10.1016/S0029-7844(01)01684-2"
    },
    "kim_2025": {
      "topic": "iron_biology_clinical_context",
      "short": "Kim et al. 2025",
      "apa": "Kim, M., Chang, Y., Cho, Y., Kwon, M.-J., Joh, H.-K., Lim, G.-Y., Kwon, R., Ahn, J., Park, J., Kim, K.-H., Yoo, J. K., & Ryu, S. (2025). Accelerated increase in ferritin levels during menopausal transition as a marker of metabolic health. Scientific Reports, 15(1), 29311.",
      "doi_url": "https://doi.org/10.1038/s41598-025-14295-3"
    },
    "parker_2020": {
      "topic": "ferritin_thresholds",
      "short": "Parker et al. 2021",
      "apa": "Parker, M. L., Storm, S., Sholzberg, M., Yip, P. M., & Beriault, D. R. (2021). Revising ferritin lower limits: It's time to raise the bar on iron deficiency. The Journal of Applied Laboratory Medicine, 6(3), 765–773.",
      "doi_url": "https://doi.org/10.1093/jalm/jfaa152"
    },
    "means_2024": {
      "topic": "ferritin_thresholds",
      "short": "Means 2024",
      "apa": "Means, R. T. (2024). Ferritin reference intervals in a population of working-age adults without anemia. American Journal of Hematology, 99(10), 2033–2035.",
      "doi_url": "https://doi.org/10.1002/ajh.27444"
    },
    "merlo_2023": {
      "topic": "iron_biology_clinical_context",
      "short": "Merlo et al. 2023",
      "apa": "Merlo, F., Groothof, D., Khatami, F., Ahanchi, N. S., Wehrli, F., Bakker, S. J. L., Eisenga, M. F., & Muka, T. (2023). Changes in iron status biomarkers with advancing age according to sex and menopause: A population-based study. Journal of Clinical Medicine, 12(16), 5338.",
      "doi_url": "https://doi.org/10.3390/jcm12165338"
    },
    "foy_2019": {
      "topic": "ferritin_thresholds",
      "short": "Foy et al. 2020",
      "apa": "Foy, B. H., Li, A., McClung, J. P., Ranganath, R., & Higgins, J. M. (2020). Data-driven physiologic thresholds for iron deficiency associated with hematologic decline. American Journal of Hematology, 95(3), 302–309.",
      "doi_url": "https://doi.org/10.1002/ajh.25706"
    },
    "warne_2017": {
      "topic": "iron_overload",
      "short": "Warne et al. 2017",
      "apa": "Warne, C. D., Zaloumis, S. G., Bertalli, N. A., Delatycki, M. B., Nicoll, A. J., McLaren, C. E., Hopper, J. L., Giles, G. G., Anderson, G. J., Olynyk, J. K., Powell, L. W., Allen, K. J., & Gurrin, L. C. (2017). HFE p.C282Y homozygosity predisposes to rapid serum ferritin rise after menopause: A genetic study and systematic review. Journal of Gastroenterology and Hepatology, 32(4), 797–802.",
      "doi_url": "https://doi.org/10.1111/jgh.13621"
    },
    "wouters_2019": {
      "topic": "hemoglobin_thresholds",
      "short": "Wouters et al. 2019",
      "apa": "Wouters, H. J. C. M., van der Klauw, M. M., de Witte, T., Stauder, R., Swinkels, D. W., Wolffenbuttel, B. H. R., & Huls, G. (2019). Association of anemia with health-related quality of life and survival: A large population-based cohort study. Haematologica, 104(3), 468–476.",
      "doi_url": "https://doi.org/10.3324/haematol.2018.195552"
    },
    "easl_2022": {
      "topic": "iron_overload",
      "short": "EASL 2022",
      "apa": "European Association for the Study of the Liver. (2022). EASL clinical practice guidelines on haemochromatosis. Journal of Hepatology, 77(2), 479–502.",
      "doi_url": "https://doi.org/10.1016/j.jhep.2022.03.033"
    },
    "adams_2005": {
      "topic": "iron_overload",
      "short": "Adams et al. 2005",
      "apa": "Adams, P. C., Reboussin, D. M., Barton, J. C., McLaren, C. E., Eckfeldt, J. H., McLaren, G. D., Dawkins, F. W., Acton, R. T., Harris, E. L., Gordeuk, V. R., Leiendecker-Foster, C., Speechley, M., Snively, B. M., Holup, J. L., Thomson, E., & Sholinsky, P. (2005). Hemochromatosis and iron-overload screening in a racially diverse population. New England Journal of Medicine, 352(17), 1769–1778.",
      "doi_url": "https://doi.org/10.1056/NEJMoa041534"
    },
    "adams_2015": {
      "topic": "iron_overload",
      "short": "Adams 2015",
      "apa": "Adams, P. C. (2015). Epidemiology and diagnostic testing for hemochromatosis and iron overload. International Journal of Laboratory Hematology, 37(S1), 25–30.",
      "doi_url": "https://doi.org/10.1111/ijlh.12347"
    },
    "allen_2008": {
      "topic": "iron_overload",
      "short": "Allen et al. 2008",
      "apa": "Allen, K. J., Gurrin, L. C., Constantine, C. C., Osborne, N. J., Delatycki, M. B., Nicoll, A. J., McLaren, C. E., Bahlo, M., Nisselle, A. E., Vulpe, C. D., Anderson, G. J., Southey, M. C., Giles, G. G., English, D. R., Hopper, J. L., Olynyk, J. K., Powell, L. W., & Gertig, D. M. (2008). Iron-overload-related disease in HFE hereditary hemochromatosis. New England Journal of Medicine, 358(3), 221–230.",
      "doi_url": "https://doi.org/10.1056/NEJMoa073286"
    },
    "waalen_2008": {
      "topic": "iron_overload",
      "short": "Waalen et al. 2008",
      "apa": "Waalen, J., Felitti, V. J., Gelbart, T., & Beutler, E. (2008). Screening for hemochromatosis by measuring ferritin levels: A more effective approach. Blood, 111(7), 3373–3376.",
      "doi_url": "https://doi.org/10.1182/blood-2007-07-102673"
    },
    "lim_2014": {
      "topic": "iron_overload",
      "short": "Lim et al. 2014",
      "apa": "Lim, A., Speechley, M., & Adams, P. C. (2014). Predicting C282Y homozygote genotype for hemochromatosis using serum ferritin and transferrin saturation values from 44,809 participants of the HEIRS Study. Canadian Journal of Gastroenterology and Hepatology, 28(9), 502–504.",
      "doi_url": "https://doi.org/10.1155/2014/698352"
    },
    "lou_2024": {
      "topic": "iron_overload",
      "short": "Lou et al. 2024",
      "apa": "Lou, A., Elnenaei, M. O., Zhu, J., Peltekian, K., Liu, E., Jamieson, J. A., Said, H., & Nassar, B. A. (2025). Re-evaluating the utility of iron indices in hereditary hemochromatosis genotyping: A retrospective study. Clinical Biochemistry, 135, 110860.",
      "doi_url": "https://doi.org/10.1016/j.clinbiochem.2024.110860"
    },
    "cacoub_2019": {
      "topic": "iron_studies",
      "short": "Cacoub et al. 2019",
      "apa": "Cacoub, P., Vandewalle, C., & Peoc'h, K. (2019). Using transferrin saturation as a diagnostic criterion for iron deficiency: A systematic review. Critical Reviews in Clinical Laboratory Sciences, 56(8), 526–532.",
      "doi_url": "https://doi.org/10.1080/10408363.2019.1653820"
    },
    "cacoub_2022": {
      "topic": "functional_iron_deficiency",
      "short": "Cacoub et al. 2022",
      "apa": "Cacoub, P., Choukroun, G., Cohen-Solal, A., Luporsi, E., Peyrin-Biroulet, L., Peoc'h, K., Andrieu, V., Lasocki, S., Puy, H., & Trochu, J.-N. (2022). Iron deficiency screening is a key issue in chronic inflammatory diseases: A call to action. Journal of Internal Medicine, 292(4), 542–556.",
      "doi_url": "https://doi.org/10.1111/joim.13503"
    },
    "braat_2024": {
      "topic": "hemoglobin_thresholds",
      "short": "Braat et al. 2024",
      "apa": "Braat, S., Fielding, K. L., Han, J., Jackson, V. E., Zaloumis, S., Xu, J. X. H., Moir-Meyer, G., Blaauwendraad, S. M., Jaddoe, V. W. V., Gaillard, R., Parkin, P. C., Borkhoff, C. M., Keown-Stoneman, C. D. G., Birken, C. S., Maguire, J. L., Bahlo, M., Davidson, E. M., & Pasricha, S.-R. (2024). Haemoglobin thresholds to define anaemia from age 6 months to 65 years: Estimates from international data sources. The Lancet Haematology, 11(4), e253–e264.",
      "doi_url": "https://doi.org/10.1016/S2352-3026(24)00030-9"
    },
    "young_2023": {
      "topic": "hemoglobin_thresholds",
      "short": "Young et al. 2023",
      "apa": "Young, M. F., Oaks, B. M., Rogers, H. P., Tandon, S., Martorell, R., Dewey, K. G., & Wendt, A. S. (2023). Maternal low and high hemoglobin concentrations and associations with adverse maternal and infant health outcomes: An updated global systematic review and meta-analysis. BMC Pregnancy and Childbirth, 23(1), 264.",
      "doi_url": "https://doi.org/10.1186/s12884-023-05489-6"
    },
    "shinar_2018": {
      "topic": "hemoglobin_thresholds",
      "short": "Shinar et al. 2018",
      "apa": "Shinar, S., Shapira, U., & Maslovitz, S. (2018). Redefining normal hemoglobin and anemia in singleton and twin pregnancies. International Journal of Gynecology & Obstetrics, 142(1), 42–47.",
      "doi_url": "https://doi.org/10.1002/ijgo.12506"
    },
    "mansukhani_2023": {
      "topic": "hemoglobin_thresholds",
      "short": "WOMAN-2 Trial Collaborators 2023",
      "apa": "The WOMAN-2 Trial Collaborators. (2023). Maternal anaemia and the risk of postpartum haemorrhage: A cohort analysis of data from the WOMAN-2 trial. The Lancet Global Health, 11(8), e1249–e1259.",
      "doi_url": "https://doi.org/10.1016/S2214-109X(23)00245-0",
      "note": "Group authorship; S. Mansukhani chaired the writing committee."
    },
    "butwick_2016": {
      "topic": "hemoglobin_thresholds",
      "short": "Butwick et al. 2017",
      "apa": "Butwick, A. J., Walsh, E. M., Kuzniewicz, M., Li, S. X., & Escobar, G. J. (2017). Patterns and predictors of severe postpartum anemia after Cesarean section. Transfusion, 57(1), 36–44.",
      "doi_url": "https://doi.org/10.1111/trf.13815"
    },
    "netz_2024": {
      "topic": "hemoglobin_thresholds",
      "short": "Netz et al. 2024",
      "apa": "Netz, A., Hof, L., Rumpf, F., Blum, L. V., Neef, V., Kerner, A., Zacharowski, K., Meybohm, P., & Choorapoikayil, S. (2024). Adjusting current hemoglobin thresholds: A way to improve outcome in women undergoing major surgery. Journal of Women's Health, 33(5), 678–684.",
      "doi_url": "https://doi.org/10.1089/jwh.2023.0665"
    },
    "namaste_2017": {
      "topic": "inflammation_adjustment",
      "short": "Namaste et al. 2017 (BRINDA ferritin)",
      "apa": "Namaste, S. M. L., Rohner, F., Huang, J., Bhushan, N. L., Flores-Ayala, R., Kupka, R., Mei, Z., Rawat, R., Williams, A. M., Raiten, D. J., Northrop-Clewes, C. A., & Suchdev, P. S. (2017). Adjusting ferritin concentrations for inflammation: Biomarkers Reflecting Inflammation and Nutritional Determinants of Anemia (BRINDA) project. The American Journal of Clinical Nutrition, 106(Suppl. 1), 359S–371S.",
      "doi_url": "https://doi.org/10.3945/ajcn.116.141762"
    },
    "who_2024": {
      "topic": "hemoglobin_thresholds",
      "short": "WHO 2024",
      "apa": "World Health Organization. (2024). WHO guideline on haemoglobin cutoffs to define anaemia in individuals and populations. World Health Organization.",
      "doi_url": "https://www.who.int/publications/i/item/9789240088542",
      "note": "Organizational guideline. Underlying evidence base is the Braat 2024 commissioned IPD meta-analysis."
    },
    "thurnham_2010": {
      "topic": "inflammation_adjustment",
      "short": "Thurnham et al. 2010",
      "apa": "Thurnham, D. I., McCabe, L. D., Haldar, S., Wieringa, F. T., Northrop-Clewes, C. A., & McCabe, G. P. (2010). Adjusting plasma ferritin concentrations to remove the effects of subclinical inflammation in the assessment of iron deficiency: A meta-analysis. The American Journal of Clinical Nutrition, 92(3), 546–555.",
      "doi_url": "https://doi.org/10.3945/ajcn.2010.29284"
    },
    "williams_2019": {
      "topic": "inflammation_adjustment",
      "short": "Williams et al. 2019",
      "apa": "Williams, A. M., Ladva, C. N., Leon, J. S., Lopman, B. A., Tangpricha, V., Whitehead, R. D., Jr., Armitage, A. E., Wray, K., Morovat, A., Pasricha, S.-R., Thurnham, D., Tanumihardjo, S. A., Shahab-Ferdows, S., Allen, L., Flores-Ayala, R. C., & Suchdev, P. S. (2019). Changes in micronutrient and inflammation serum biomarker concentrations after a norovirus human challenge. American Journal of Clinical Nutrition, 110(6), 1456–1464.",
      "doi_url": "https://doi.org/10.1093/ajcn/nqz201"
    },
    "ko_2024": {
      "topic": "inflammation_adjustment",
      "short": "Ko et al. 2024",
      "apa": "Ko, Y.-A., Suchdev, P. S., Geng, J., Luo, H., Young, M. F., & Williams, A. M. (2024). Evaluation of inflammation adjustment methods to assess iron deficiency using longitudinal data from norovirus human challenge trials. PLOS Global Public Health, 4(12), e0003964.",
      "doi_url": "https://doi.org/10.1371/journal.pgph.0003964"
    },
    "tarancon_diez_2022": {
      "topic": "ferritin_thresholds",
      "short": "Tarancón-Diez et al. 2022",
      "apa": "Tarancón-Diez, L., Genebat, M., Roman-Enry, M., Vázquez-Alejo, E., Espinar-Buitrago, M. d. l. S., Leal, M., & Muñoz-Fernandez, M. Á. (2022). Threshold ferritin concentrations reflecting early iron deficiency based on hepcidin and soluble transferrin receptor serum levels in patients with absolute iron deficiency. Nutrients, 14(22), 4739.",
      "doi_url": "https://doi.org/10.3390/nu14224739"
    },
    "brownlie_2004": {
      "topic": "iron_biology_clinical_context",
      "short": "Brownlie et al. 2004",
      "apa": "Brownlie, T., IV, Utermohlen, V., Hinton, P. S., & Haas, J. D. (2004). Tissue iron deficiency without anemia impairs adaptation in endurance capacity after aerobic training in previously untrained women. The American Journal of Clinical Nutrition, 79(3), 437–443.",
      "doi_url": "https://doi.org/10.1093/ajcn/79.3.437"
    },
    "choorapoikayil_2025": {
      "topic": "iron_studies",
      "short": "Choorapoikayil et al. 2025",
      "apa": "Choorapoikayil, S., Kotlyar, M. J., Kawohl, L., Pratz, P. P., Mehic, D., Kranke, P., Rumpf, F., Blum, L. V., Kloka, J. A., Zacharowski, K., Neef, V., & Meybohm, P. (2025). Reticulocyte hemoglobin content: A new frontier in iron deficiency diagnostics for major surgical patients. BMC Anesthesiology, 25(1), 40.",
      "doi_url": "https://doi.org/10.1186/s12871-025-02905-6"
    },
    "skikne_2011": {
      "topic": "anemia_of_chronic_disease",
      "short": "Skikne et al. 2011",
      "apa": "Skikne, B. S., Punnonen, K., Caldron, P. H., Bennett, M. T., Rehu, M., Gasior, G. H., Chamberlin, J. S., Sullivan, L. A., Bray, K. R., & Southwick, P. C. (2011). Improved differential diagnosis of anemia of chronic disease and iron deficiency anemia: A prospective multicenter evaluation of soluble transferrin receptor and the sTfR/log ferritin index. American Journal of Hematology, 86(11), 923–927.",
      "doi_url": "https://doi.org/10.1002/ajh.22108"
    },
    "kuragano_2020": {
      "topic": "functional_iron_deficiency",
      "short": "Kuragano et al. 2020",
      "apa": "Kuragano, T., Joki, N., Hase, H., Kitamura, K., Murata, T., Fujimoto, S., Fukatsu, A., Inoue, T., Itakura, Y., & Nakanishi, T. (2020). Low transferrin saturation (TSAT) and high ferritin levels are significant predictors for cerebrovascular and cardiovascular disease and death in maintenance hemodialysis patients. PLoS ONE, 15(9), e0236277.",
      "doi_url": "https://doi.org/10.1371/journal.pone.0236277"
    },
    "rambod_2008": {
      "topic": "functional_iron_deficiency",
      "short": "Rambod et al. 2008",
      "apa": "Rambod, M., Kovesdy, C. P., & Kalantar-Zadeh, K. (2008). Combined high serum ferritin and low iron saturation in hemodialysis patients: The role of inflammation. Clinical Journal of the American Society of Nephrology, 3(6), 1691–1701.",
      "doi_url": "https://doi.org/10.2215/CJN.01070308"
    },
    "dignass_2018": {
      "topic": "functional_iron_deficiency",
      "short": "Dignass et al. 2018",
      "apa": "Dignass, A., Farrag, K., & Stein, J. (2018). Limitations of serum ferritin in diagnosing iron deficiency in inflammatory conditions. International Journal of Chronic Diseases, 2018, 9394060.",
      "doi_url": "https://doi.org/10.1155/2018/9394060"
    },
    "rohr_2023": {
      "topic": "anemia_of_chronic_disease",
      "short": "Rohr et al. 2023",
      "apa": "Rohr, M., Brandenburg, V., & Brunner-La Rocca, H.-P. (2023). How to diagnose iron deficiency in chronic disease: A review of current methods and potential marker for the outcome. European Journal of Medical Research, 28(1), 15.",
      "doi_url": "https://doi.org/10.1186/s40001-022-00922-6"
    },
    "svenson_2021": {
      "topic": "anemia_of_chronic_disease",
      "short": "Svenson et al. 2021",
      "apa": "Svenson, N., Bailey, J., Durairaj, S., & Dempsey-Hibbert, N. (2021). A simplified diagnostic pathway for the differential diagnosis of iron deficiency anaemia and anaemia of chronic disease. International Journal of Laboratory Hematology, 43(6), 1644–1652.",
      "doi_url": "https://doi.org/10.1111/ijlh.13666"
    },
    "deniz_2022": {
      "topic": "anemia_of_chronic_disease",
      "short": "Deniz & Karaahmetoglu 2023",
      "apa": "Deniz, M. S., & Karaahmetoglu, S. (2023). Novel diagnostic parameters in the differentiation of isolated iron deficiency and iron deficiency accompanying chronic disease before progressing anemia. Eurasian Journal of Medicine and Investigation, 7(2), 141–145.",
      "doi_url": "https://doi.org/10.14744/ejmi.2023.93800"
    },
    "murawska_2016": {
      "topic": "anemia_of_chronic_disease",
      "short": "Murawska et al. 2016",
      "apa": "Murawska, N., Fabisiak, A., & Fichna, J. (2016). Anemia of chronic disease and iron deficiency anemia in inflammatory bowel diseases: Pathophysiology, diagnosis, and treatment. Inflammatory Bowel Diseases, 22(5), 1198–1208.",
      "doi_url": "https://doi.org/10.1097/MIB.0000000000000648"
    },
    "auerbach_2025": {
      "topic": "iron_biology_clinical_context",
      "short": "Auerbach et al. 2025",
      "apa": "Auerbach, M., DeLoughery, T. G., & Tirnauer, J. S. (2025). Iron deficiency in adults: A review. JAMA, 333(20), 1813–1823.",
      "doi_url": "https://doi.org/10.1001/jama.2025.0452"
    },
    "schmitt_2005": {
      "topic": "iron_overload",
      "short": "Schmitt et al. 2005",
      "apa": "Schmitt, B., Golub, R. M., & Green, R. (2005). Screening primary care patients for hereditary hemochromatosis with transferrin saturation and serum ferritin level: Systematic review for the American College of Physicians. Annals of Internal Medicine, 143(7), 522–536.",
      "doi_url": "https://doi.org/10.7326/0003-4819-143-7-200510040-00011"
    },
    "cullis_2018": {
      "topic": "iron_overload",
      "short": "Cullis et al. 2018",
      "apa": "Cullis, J. O., Fitzsimons, E. J., Griffiths, W. J. H., Tsochatzis, E., & Thomas, D. W. (2018). Investigation and management of a raised serum ferritin. British Journal of Haematology, 181(3), 331–340.",
      "doi_url": "https://doi.org/10.1111/bjh.15166"
    },
    "goubran_2024": {
      "topic": "iron_overload",
      "short": "Goubran et al. 2024",
      "apa": "Goubran, M., Spaner, C., Stukas, S., Zoref-Lorenz, A., Shojania, K., Beckett, M., Li, A., Peterson, E., Sekhon, M., Grey, R., Wellington, C., Cheng, C. V., Biggs, C. M., Mattman, A., Jordan, M. B., Chen, L. Y. C., & Setiadi, A. (2024). The role of C-reactive protein and ferritin in the diagnosis of HLH, adult-onset Still's disease, and COVID-19 cytokine storm. Scientific Reports, 14(1), 31306.",
      "doi_url": "https://doi.org/10.1038/s41598-024-82760-6"
    },
    "cappellini_2020": {
      "topic": "morphology_differential",
      "short": "Cappellini et al. 2020",
      "apa": "Cappellini, M. D., Russo, R., Andolfo, I., & Iolascon, A. (2020). Inherited microcytic anemias. Hematology. American Society of Hematology. Education Program, 2020(1), 465–470.",
      "doi_url": "https://doi.org/10.1182/hematology.2020000158"
    },
    "van_zeben_1990": {
      "topic": "red_cell_indices",
      "short": "van Zeben et al. 1990",
      "apa": "van Zeben, D., Bieger, R., van Wermeskerken, R. K. A., Castel, A., & Hermans, J. (1990). Evaluation of microcytosis using serum ferritin and red blood cell distribution width. European Journal of Haematology, 44(2), 105–108.",
      "doi_url": "https://doi.org/10.1111/j.1600-0609.1990.tb00359.x"
    },
    "hans_2024": {
      "topic": "morphology_differential",
      "short": "Hans et al. 2024",
      "apa": "Hans, A., Atreja, C. B., & Batra, N. (2024). Distinguishing iron deficiency anemia from beta-thalassemia trait: Comparative analysis of CRUISE index and other traditional diagnostic indices. Cureus, 16(7), e64048.",
      "doi_url": "https://doi.org/10.7759/cureus.64048"
    },
    "mondal_2021": {
      "topic": "morphology_differential",
      "short": "Mondal et al. 2021",
      "apa": "Mondal, B., Parvez, M., Rana, M. M., Rahman, L., Zahan, R., Pal, K. C., & Khan, W. A. (2021). Status of red blood cell indices in iron deficiency anemia and β-thalassaemia trait: A comparative study. Dhaka Shishu (Children) Hospital Journal, 37(1), 9–14.",
      "doi_url": "https://doi.org/10.3329/dshj.v37i1.59087"
    },
    "thambiraj_2023": {
      "topic": "morphology_differential",
      "short": "Thambiraj et al. 2023",
      "apa": "Thambiraj, P., Nanda, N., & Kar, R. (2023). Utility of red blood cell parameters and indices of iron homeostasis in evaluation of microcytosis without anemia or with mild anemia: A diagnostic accuracy study. Journal of Laboratory Physicians, 16(2), 171–180.",
      "doi_url": "https://doi.org/10.1055/s-0043-1774293"
    },
    "defreyne_2018": {
      "topic": "iron_biology_clinical_context",
      "short": "Defreyne et al. 2018",
      "apa": "Defreyne, J., Vantomme, B., Van Caenegem, E., Wierckx, K., De Blok, C. J. M., Klaver, M., Nota, N. M., Van Dijk, D., Wiepjes, C. M., Den Heijer, M., & T'Sjoen, G. (2018). Prospective evaluation of hematocrit in gender-affirming hormone treatment: Results from European Network for the Investigation of Gender Incongruence. Andrology, 6(3), 446–454.",
      "doi_url": "https://doi.org/10.1111/andr.12485"
    },
    "bachman_2013": {
      "topic": "iron_biology_clinical_context",
      "short": "Bachman et al. 2014",
      "apa": "Bachman, E., Travison, T. G., Basaria, S., Davda, M. N., Guo, W., Li, M., Connor Westfall, J., Bae, H., Gordeuk, V., & Bhasin, S. (2014). Testosterone induces erythrocytosis via increased erythropoietin and suppressed hepcidin: Evidence for a new erythropoietin/hemoglobin set point. The Journals of Gerontology: Series A, Biological Sciences and Medical Sciences, 69(6), 725–735.",
      "doi_url": "https://doi.org/10.1093/gerona/glt154",
      "note": "Online 2013, final issue 2014; cited in methodology as Bachman 2013."
    },
    "olsen_2010": {
      "topic": "iron_biology_clinical_context",
      "short": "Olsen et al. 2010",
      "apa": "Olsen, E. A., Reed, K. B., Cacchio, P. B., & Caudill, L. (2010). Iron deficiency in female pattern hair loss, chronic telogen effluvium, and control groups. Journal of the American Academy of Dermatology, 63(6), 991–999.",
      "doi_url": "https://doi.org/10.1016/j.jaad.2009.12.006"
    },
    "mettananda_2020": {
      "topic": "morphology_differential",
      "short": "Mettananda et al. 2020",
      "apa": "Mettananda, S., Paranamana, S., Fernando, R., Suranjan, M., Rodrigo, R., Perera, L., Vipulaguna, T., Fernando, P., Fernando, M., Dayanath, B. K. T. P., Costa, Y., & Premawardhena, A. (2020). Microcytic anemia in children: Parallel screening for iron deficiency and thalassemia provides a useful opportunity for thalassemia prevention in low- and middle-income countries. Pediatric Hematology and Oncology, 37(4), 326–336.",
      "doi_url": "https://doi.org/10.1080/08880018.2020.1725200"
    },
    "savatt_2023": {
      "topic": "iron_overload",
      "short": "Savatt et al. 2023",
      "apa": "Savatt, J. M., Johns, A., Schwartz, M. L. B., McDonald, W. S., Salvati, Z. M., Ortiz, N. M., Masnick, M., Hatchell, K., Hao, J., Buchanan, A. H., & Williams, M. S. (2023). Testing and management of iron overload after genetic screening–identified hemochromatosis. JAMA Network Open, 6(10), e2338995.",
      "doi_url": "https://doi.org/10.1001/jamanetworkopen.2023.38995"
    },
    "young_2019_brinda": {
      "topic": "inflammation_adjustment",
      "short": "Young et al. 2019 (BRINDA pregnancy abstract)",
      "apa": "Young, M., Luo, H., Peerson, J., Addo, Y., Ko, Y.-A., & Suchdev, P. (2019). Adjusting iron biomarkers for inflammation in pregnant women: Biomarkers Reflecting Inflammation and Nutritional Determinants of Anemia (BRINDA) project (P10-122-19). Current Developments in Nutrition, 3(Suppl 1), nzz034.P10-122-19.",
      "doi_url": "https://doi.org/10.1093/cdn/nzz034.P10-122-19"
    },
    "weli_2024": {
      "topic": "red_cell_indices",
      "short": "Weli et al. 2024",
      "apa": "Weli, H., Hernandez, P., & Frater, J. (2024). Critical appraisal of the utility of 13 discriminant formulas for distinguishing beta thalassemia trait from iron deficiency in patients with microcytic anemia and the introduction of a new formula in a USA population. American Journal of Clinical Pathology, 162(Suppl 1), S167.",
      "doi_url": "https://doi.org/10.1093/ajcp/aqae129.368"
    },
    "hirosawa_2022": {
      "topic": "iron_studies",
      "short": "Hirosawa et al. 2022",
      "apa": "Hirosawa, T., Hayashi, A., Harada, Y., & Shimizu, T. (2022). The clinical and biological manifestations in women with iron deficiency without anemia compared to iron deficiency anemia in a general internal medicine setting: A retrospective cohort study. International Journal of General Medicine, 15, 6765–6773.",
      "doi_url": "https://doi.org/10.2147/IJGM.S376405"
    },
    "wiser_2024": {
      "topic": "iron_biology_clinical_context",
      "short": "Wiser et al. 2024",
      "apa": "Wiser, A. L., Knight, L. M., Satow, D., Carmichael, K. C., Boucher, S. E., Hayward-Hill, T., & Vollbrecht, H. (2024). Impact of gender affirming hormone therapy on hematological values of transgender and gender diverse patients. American Journal of Medical and Clinical Research & Reviews.",
      "doi_url": "https://www.amjmcrr.org/"
    }
  }
}
